import { IconArrow, APPLY_ANCHOR } from './UEShared';

const UEHeroSection = () => (
  <>
    <header className="hero">
      <div className="hero-inner">
        <div className="hero-text">
          <div className="partnership-lockup">
            <img className="partnership-flink-mark" src="/assets/flink-wordmark.svg" alt="Flink" />
            <span className="partnership-x">×</span>
            <img className="partnership-ue" src="/assets/uber-eats-icon.svg" alt="Uber Eats" />
          </div>

          <div className="hero-chips">
            <span className="chip chip-live">
              <span className="dot" aria-hidden="true" />
              Hiring now in Amsterdam, Groningen and Rotterdam
            </span>
            <span className="chip chip-meta">Own bike or scooter required</span>
          </div>

          <h1>
            <span style={{ color: '#E81F76' }}>Ride with a Flink contract.</span>{' '}
            <span className="accent">Deliver with Uber Eats.</span>
          </h1>

          <p className="hero-sub">
            An <strong>employed</strong> rider role in Amsterdam, Groningen and Rotterdam —
            exclusive to the Flink × Uber Eats partnership.
          </p>

          <div className="hero-ctas">
            <a href={APPLY_ANCHOR} className="btn btn-primary btn-large">
              Apply now <IconArrow />
            </a>
            <a href="#why" className="btn btn-outline btn-large">
              Benefits
            </a>
          </div>
        </div>

        <div className="hero-visual">
          <div className="hero-photo">
            <img
              src="/assets/hero-rider.webp"
              alt="Flink rider in Uber Eats kit on an Amsterdam, Groningen and Rotterdam street"
            />
          </div>
        </div>
      </div>
    </header>

    <div className="stat-strip">
      <div className="stat-strip-inner">
        <div className="stat-cell">
          <span className="stat-number">€16.19/h</span>
          <span className="stat-label">Starting wage for 21yo+</span>
        </div>
        <div className="stat-cell">
          <span className="stat-number">100%</span>
          <span className="stat-label">Of every tip, yours</span>
        </div>
        <div className="stat-cell">
          <span className="stat-number">+€0.19/km</span>
          <span className="stat-label">bike bonus per km</span>
        </div>
        <div className="stat-cell">
          <span className="stat-number">Flink Contract</span>
          <span className="stat-label">Weekly Payroll</span>
        </div>
      </div>
    </div>
  </>
);

export default UEHeroSection;
